import React from 'react';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Box, Button, Fade, Tooltip, Typography } from '@mui/material';
import { black1, grey12, red2, red3, red4 } from 'app/components/ThemeProvider/colors';
import {
  accordionDetail,
  balanceWithBtnsBox,
  detailsBox,
  detailsBtns,
  detailsWraper,
  lineBorder,
} from './CardDetails.sx';
import IncomingPlus from 'app/components/Icons/IncomingPlus';
import RequisiteModal from 'app/components/RequisiteModal';
import ExtractModal from 'app/components/ExtractModal';
import LockIcon from 'app/components/Icons/LockIcon';
import CustomSwitch from 'app/components/CustomSwitch';
import InfoIcon from 'app/components/Icons/InfoIcon';
import logger from 'app/utils/logger';
import { useLocation, useNavigate } from 'react-router-dom';
import { docInfoBox, docInfoText } from 'app/pages/HomePage/AccountsBox/AccountsBox.sx';
import DashboardWarningIcon from 'app/components/Icons/DashboardWarningIcon';

interface DetailsProps {
  cardOptions: any;
  cardValue: any;
  cardOnChange: (newValue: any) => void;
  status?: any;
  smsNotif?: any;
  handleSwitch?: any;
  index?: any;
  handleCardStatus?: any;
  cardsList: any[];
  blockCard?: any;
}
const CardDetails = (props: DetailsProps) => {
  const { cardValue, status, smsNotif, handleSwitch, index, handleCardStatus, cardsList, blockCard } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const navigateToTransfer = () => {
    navigate(`${lang}/transfer-page`, { state: { selectedValue: cardValue } });
  };

  return (
    <AccordionDetails sx={accordionDetail}>
      <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
        <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Balans</Typography>
        <Box sx={balanceWithBtnsBox}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '24px' }}>
            <Typography sx={{ fontSize: '44px', fontWeight: 600 }}>{cardValue.balance} ₼</Typography>
            {cardValue?.taxOrder === 'YES' && (
              <Box sx={docInfoBox}>
                <DashboardWarningIcon />
                <Typography sx={docInfoText}>Sərəncam</Typography>
              </Box>
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '12px', flexWrap: 'wrap' }}>
            <Button sx={detailsBtns} onClick={navigateToTransfer}>
              <IncomingPlus />
              Mədaxil
            </Button>
            {/* {status === 'BLOCKED' && ( */}
            {/*   <Button */}
            {/*     sx={{ ...detailsBtns, color: '#FF9E1F', background: 'rgba(255, 158, 31, 0.1)' }} */}
            {/*     onClick={() => handleCardStatus(cardValue.iban, cardValue.cardNum, status)} */}
            {/*   > */}
            {/*     <LockIcon type={'unlocked'} /> */}
            {/*     Blokdan çıxar */}
            {/*   </Button> */}
            {/* )} */}
            <RequisiteModal accountValue={cardValue.iban} accountCurrency={cardValue.currency}></RequisiteModal>
            <ExtractModal accountsList={cardsList} accountValue={cardValue.iban}></ExtractModal>
            {/* {status === 'ACTIVE' && ( */}
            {/*   <Button */}
            {/*     sx={{ display: 'flex', gap: '12px', color: red2, background: red4, '&:hover': { background: red3 } }} */}
            {/*     onClick={() => handleCardStatus(cardValue.iban, cardValue.cardNum, status)} */}
            {/*   > */}
            {/*     <LockIcon /> */}
            {/*     Bloklaşdırmaq */}
            {/*   </Button> */}
            {/* )} */}
          </Box>
        </Box>
      </Box>
      <Box sx={lineBorder}></Box>
      <Box sx={{ mt: '28px', mb: '8px', display: 'flex', gap: '52px' }}>
        <Box sx={detailsBox}>
          <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Bloklaşdırılmış məbləğ</Typography>
          <Typography sx={{ fontSize: '22px', fontWeight: 600, color: red2 }}>{cardValue.blocked} ₼</Typography>
        </Box>
        {cardValue.govAmount > 0 && (
          <Box sx={detailsBox}>
            <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Dövlət vəsaiti</Typography>
            <Typography sx={{ fontSize: '22px', fontWeight: 600, color: '#FF9E1F' }}>
              {cardValue.govAmount} ₼
            </Typography>
          </Box>
        )}
      </Box>
      <Box sx={detailsWraper}>
        <Box sx={detailsBox}>
          <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Kartın nömrəsi</Typography>
          <Typography sx={{ fontSize: '22px', fontWeight: 600 }}>{cardValue.cardNum}</Typography>
        </Box>
        <Box sx={detailsBox}>
          <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>İstifadə müddəti</Typography>
          <Typography sx={{ fontSize: '22px', fontWeight: 600 }}>{cardValue.expDate}</Typography>
        </Box>
        <Box sx={detailsBox}>
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>
              SMS məlumatlandırma xidməti
            </Typography>
            <Tooltip
              title="Xidmət haqqı: aylıq 5 AZN"
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    color: black1,
                    border: '0.5px solid rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Yelo',

                    '& .MuiTooltip-arrow': {
                      color: '#ffffff',
                    },
                  },
                },
                arrow: {
                  sx: {
                    '&:before': {
                      border: '0.5px solid rgba(0, 0, 0, 0.1)',
                    },
                  },
                },
              }}
            >
              <Box>
                <InfoIcon color="primary" />
              </Box>
            </Tooltip>
          </Box>
          <CustomSwitch
            sx={{ height: '24px' }}
            title={smsNotif ? 'Aktiv' : 'Deaktiv'}
            checked={smsNotif}
            handleToggleArr={handleSwitch}
            index={index}
          />
        </Box>
        <Box sx={detailsBox}>
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '17px', fontWeight: 400, color: grey12 }}>Kartı bloklamaq</Typography>
          </Box>
          <CustomSwitch
            color={'secondary'}
            sx={{ height: '24px' }}
            title={blockCard ? 'Blokdan çıxar' : 'Blok et'}
            checked={blockCard}
            handleToggleArr={handleCardStatus}
            index={index}
          />
        </Box>
      </Box>
    </AccordionDetails>
  );
};

export default CardDetails;
